import { useSalesContext } from "../../../../../sales-context/SalesContext";
import { useCallDetailsStore } from "../../../../../stores";
import { getMappedIntent } from "./getMappedIntent";

/**
 * useIVRInfo — reads IVR data from SalesContext.ivrInfo and callDetails store.
 *
 * In expert-ui, this reads from voiceTask.ivrInfo and CSD callDetails.
 * In our decoupled version, ivrInfo comes from context (set by the bridge),
 * and CSD data comes from useCallDetailsStore.
 *
 * Intent mapping is applied via getMappedIntent for partner-specific mappings
 * (e.g., McAfee intent codes → human-readable labels).
 */
export function useIVRInfo() {
    const { ivrInfo, partner } = useSalesContext();

    const {
        INTENT: intentFromCSD,
        SUMMARY: summaryFromCSD,
        CUSTOMER_NAME: customerNameFromCSD,
        ORDER_NUMBER: orderNumberFromCSD,
        PRODUCT_LINK: productLinkFromCSD,
        PRODUCT_TITLE: productTitleFromCSD,
        BRAND_PHONE_NUMBER: brandPhoneNumberFromCSD,
        SUPPORT_PHONE_NUMBER: supportPhoneNumberFromCSD,
        ACCOUNT_ID: accountIdFromCSD,
    } = useCallDetailsStore((state) => state.callDetails) as Record<string, string | undefined>;

    const intent = ivrInfo?.intent ? getMappedIntent(ivrInfo.intent, partner) : intentFromCSD;
    const summary = ivrInfo?.summary ?? summaryFromCSD;
    const customerName = ivrInfo?.customerName ?? customerNameFromCSD;
    const orderNumber = ivrInfo?.orderNumber ?? orderNumberFromCSD;
    const productLink = ivrInfo?.productLink ?? productLinkFromCSD;
    const productTitle = ivrInfo?.productTitle ?? productTitleFromCSD;
    const brandPhoneNumber = ivrInfo?.brandPhoneNumber ?? brandPhoneNumberFromCSD;
    const supportPhoneNumber = ivrInfo?.supportPhoneNumber ?? supportPhoneNumberFromCSD;
    const accountId = ivrInfo?.accountId ?? accountIdFromCSD;

    return {
        ...ivrInfo,
        intent,
        summary,
        customerName,
        orderNumber,
        productLink,
        productTitle,
        brandPhoneNumber,
        supportPhoneNumber,
        accountId,
    };
}
